import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import { addFeedbackTemplate } from '../../services/feedbackService';
import FeedbackTemplateForm from './FeedbackTemplateForm';

function FeebackTemplateAdd(props) {
  const initialValues = {
    name: '',
    questions: []
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const onSubmit = async (values) => {
    console.log('Initial value', initialValues);
    let payload = {
      ...values
    };

    setStatus({ type: 'LOADING', message: 'Request in Progress!' });
    await addFeedbackTemplate(payload)
      .then((response) => {
        console.log('Successfully Added! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data added successfully!'
        });
      })
      .catch((error) => {
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <Modal
      title={`Add Template `}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={'*NOTE: Template added cannot be edited and deleted'}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <FeedbackTemplateForm
          type="Add"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          setStatus={setStatus}
          visible={props.isOpen}
        />
      )}
    </Modal>
  );
}

export default FeebackTemplateAdd;
